// extracted by mini-css-extract-plugin
export default {"container":"current-schedule_container__h2L5u","fullView":"current-schedule_fullView__ciTaY","shimmer":"current-schedule_shimmer__5Zfo2"};